const darkTheme = {
  fontFamily: "Roboto Condensed",
  colorPrimary: "#85D305",

  colorSecondary: "#50C1FF",
  colorItemBg: "#333333",
  colorListItem: "#191919",
  colorDarkBlack: "#000",
};
const lightTheme = {
  fontFamily: "Roboto Condensed",
  colorPrimary: "#0B8DDC",
  // borderRadius: "2px",
  colorText: "#fff",
  fontSize: "16px",
  // colorBgContainer: "rgba(0, 0, 0, 0.5)",

  colorTextBase: "#fff",
  colorItemBg: "#333333",
  colorListItem: "#191919",
  colorDarkBlack: "#000",
};
const theme = { darkTheme, lightTheme };
export default theme;
